import React from "react";

const STATS = [
    { value: "60%", label: "Increase in online orders*", note: "" },
    { value: "2–4x", label: "Faster menu updates", note: "" },
    { value: "99.9%", label: "Uptime & reliability", note: "" },
    { value: "100%", label: "Mobile‑optimized layouts", note: "" },
];

export default function ResultsSection() {
    return (
        <section className="results-section">
            <div className="container">
                <div className="results-head text-center">
                    <span className="eyebrow">Results</span>
                    <h2 className="results-title">More orders. More bookings. Less hassle.</h2>
                    <p className="results-sub">
                        We focus on outcomes that matter for restaurants, cafés, and bars: more revenue,
                        less admin, and a brand that feels as good online as it does in person.
                    </p>
                </div>

                <div className="row g-4 justify-content-center">
                    {STATS.map((s, i) => (
                        <div className="col-6 col-md-3" key={i}>
                            <div className="stat-card">
                                <div className="stat-value">{s.value}</div>
                                <div className="stat-label">{s.label}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="results-cta text-center">
                    <a href="/get-started" className="btn btn-accent-primary">
                        Get started
                    </a>
                    <a href="/pricing" className="results-link">See pricing</a>
                </div>

                <p className="results-footnote">
                    *Example performance based on typical implementations. Your results may vary.
                </p>
            </div>
        </section>
    );
}
